import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavbar from './components/TopNavbar';
import './components/TopNavbar.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function FormOverview() {
  const [stats, setStats] = useState({
    totalForms: 0,
    activeForms: 0,
    inactiveForms: 0,
    totalViews: 0,
    totalFeedback: 0,
    topForms: 0,
    countToday: 0,
    countYesterday: 0,
    countLastWeek: 0
  });
  // eslint-disable-next-line no-unused-vars
  const [statsLoading, setStatsLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();

  // 获取表单概览统计数据
  const fetchFormOverviewStats = async () => {
    setStatsLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/forms/form_overview`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      setStats({
        totalForms: data.data?.from_count || 0,
        activeForms: data.data?.preview_count || 0,
        inactiveForms: data.data?.from_close_count || 0,
        totalViews: data.data?.preview_count || 0,  // 使用preview_count作为浏览量
        totalFeedback: data.data?.submitCount || 0,
        topForms: data.data?.from_top_count || 0,
        countToday: data.data?.countToday || 0,
        countYesterday: data.data?.countYesterday || 0,
        countLastWeek: data.data?.countLastWeek || 0
      });
    } catch (e) {
      setStats({
        totalForms: 0,
        activeForms: 0,
        inactiveForms: 0,
        totalViews: 0,
        totalFeedback: 0,
        topForms: 0,
        countToday: 0,
        countYesterday: 0,
        countLastWeek: 0
      });
    } finally {
      setStatsLoading(false);
    }
  };

  useEffect(() => {
    fetchFormOverviewStats();
  }, []);

  // 统计卡片展示
  return (
    <>
      <TopNavbar />
      <div style={{ 
        background: 'linear-gradient(135deg, #f4f6fa 0%, #e9f0fb 100%)', 
        minHeight: '100vh', 
        padding: '40px 0',
        animation: 'fadeIn 0.6s ease-out'
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px' }}>
          {/* 页面标题 */}
          <div style={{ marginBottom: 40, textAlign: 'center' }}>
            <h1 style={{ 
              fontSize: 42, 
              fontWeight: 700, 
              color: '#222', 
              margin: '0 0 12px 0', 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
              WebkitBackgroundClip: 'text', 
              WebkitTextFillColor: 'transparent', 
              backgroundClip: 'text',
              animation: 'slideInDown 0.8s ease-out'
            }}>
              表单概览
            </h1>
            <p style={{ 
              fontSize: 18, 
              color: '#666', 
              margin: '0 0 24px 0',
              animation: 'slideInUp 0.8s ease-out 0.2s both'
            }}>
              实时监控所有表单的使用情况和数据统计
            </p>
          </div>

          {/* 统计卡片网格 */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
            gap: 20, 
            marginBottom: 48,
            animation: 'fadeInUp 0.8s ease-out 0.4s both'
          }}>
            {/* 总表单数 */}
            <div className="stat-card" style={{ 
              background: 'linear-gradient(135deg, #fff 0%, #fafbfc 100%)', 
              borderRadius: 20, 
              padding: 32, 
              boxShadow: '0 8px 32px rgba(102, 126, 234, 0.12)', 
              border: '1px solid rgba(102, 126, 234, 0.08)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-4px)';
              e.target.style.boxShadow = '0 12px 40px rgba(102, 126, 234, 0.18)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 32px rgba(102, 126, 234, 0.12)';
            }}>
              <div style={{ fontSize: 16, color: '#888', marginBottom: 12, fontWeight: 500 }}>总表单数</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#222' }}>{stats.totalForms}</div>
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                borderRadius: '0 20px 0 60px'
              }}></div>
            </div>

            {/* 关闭表单数 */}
            <div className="stat-card" style={{ 
              background: 'linear-gradient(135deg, #fff 0%, #fafbfc 100%)', 
              borderRadius: 20, 
              padding: 32, 
              boxShadow: '0 8px 32px rgba(217, 217, 217, 0.12)', 
              border: '1px solid rgba(217, 217, 217, 0.08)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-4px)';
              e.target.style.boxShadow = '0 12px 40px rgba(217, 217, 217, 0.18)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 32px rgba(217, 217, 217, 0.12)';
            }}>
              <div style={{ fontSize: 16, color: '#888', marginBottom: 12, fontWeight: 500 }}>关闭表单数</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#d9d9d9' }}>{stats.inactiveForms}</div>
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, rgba(217, 217, 217, 0.1) 0%, rgba(191, 191, 191, 0.1) 100%)',
                borderRadius: '0 20px 0 60px'
              }}></div>
            </div>

            {/* 总浏览量 */}
            <div className="stat-card" style={{ 
              background: 'linear-gradient(135deg, #fff 0%, #fafbfc 100%)', 
              borderRadius: 20, 
              padding: 32, 
              boxShadow: '0 8px 32px rgba(250, 173, 20, 0.12)', 
              border: '1px solid rgba(250, 173, 20, 0.08)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-4px)';
              e.target.style.boxShadow = '0 12px 40px rgba(250, 173, 20, 0.18)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 32px rgba(250, 173, 20, 0.12)';
            }}>
              <div style={{ fontSize: 16, color: '#888', marginBottom: 12, fontWeight: 500 }}>总浏览量</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#faad14' }}>{stats.totalViews}</div>
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, rgba(250, 173, 20, 0.1) 0%, rgba(255, 193, 7, 0.1) 100%)',
                borderRadius: '0 20px 0 60px'
              }}></div>
            </div>

            {/* 总反馈数 */}
            <div className="stat-card" style={{ 
              background: 'linear-gradient(135deg, #fff 0%, #fafbfc 100%)', 
              borderRadius: 20, 
              padding: 32, 
              boxShadow: '0 8px 32px rgba(255, 120, 117, 0.12)', 
              border: '1px solid rgba(255, 120, 117, 0.08)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-4px)';
              e.target.style.boxShadow = '0 12px 40px rgba(255, 120, 117, 0.18)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 32px rgba(255, 120, 117, 0.12)';
            }}>
              <div style={{ fontSize: 16, color: '#888', marginBottom: 12, fontWeight: 500 }}>总反馈数</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#ff7875' }}>{stats.totalFeedback}</div>
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, rgba(255, 120, 117, 0.1) 0%, rgba(255, 77, 79, 0.1) 100%)',
                borderRadius: '0 20px 0 60px'
              }}></div>
            </div>

            {/* 置顶表单数 */}
            <div className="stat-card" style={{ 
              background: 'linear-gradient(135deg, #fff 0%, #fafbfc 100%)', 
              borderRadius: 20, 
              padding: 32, 
              boxShadow: '0 8px 32px rgba(118, 75, 162, 0.12)', 
              border: '1px solid rgba(118, 75, 162, 0.08)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-4px)';
              e.target.style.boxShadow = '0 12px 40px rgba(118, 75, 162, 0.18)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 32px rgba(118, 75, 162, 0.12)';
            }}>
              <div style={{ fontSize: 16, color: '#888', marginBottom: 12, fontWeight: 500 }}>置顶表单数</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#764ba2' }}>{stats.topForms}</div>
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, rgba(118, 75, 162, 0.1) 0%, rgba(102, 126, 234, 0.1) 100%)',
                borderRadius: '0 20px 0 60px'
              }}></div>
            </div>

            {/* 今日提交数 */}
            <div className="stat-card" style={{ 
              background: 'linear-gradient(135deg, #fff 0%, #fafbfc 100%)', 
              borderRadius: 20, 
              padding: 32, 
              boxShadow: '0 8px 32px rgba(82, 196, 26, 0.12)', 
              border: '1px solid rgba(82, 196, 26, 0.08)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-4px)';
              e.target.style.boxShadow = '0 12px 40px rgba(82, 196, 26, 0.18)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 32px rgba(82, 196, 26, 0.12)';
            }}>
              <div style={{ fontSize: 16, color: '#888', marginBottom: 12, fontWeight: 500 }}>今日提交</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#52c41a' }}>{stats.countToday}</div>
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, rgba(82, 196, 26, 0.1) 0%, rgba(56, 158, 13, 0.1) 100%)',
                borderRadius: '0 20px 0 60px'
              }}></div>
            </div>

            {/* 昨日提交数 */}
            <div className="stat-card" style={{ 
              background: 'linear-gradient(135deg, #fff 0%, #fafbfc 100%)', 
              borderRadius: 20, 
              padding: 32, 
              boxShadow: '0 8px 32px rgba(24, 144, 255, 0.12)', 
              border: '1px solid rgba(24, 144, 255, 0.08)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-4px)';
              e.target.style.boxShadow = '0 12px 40px rgba(24, 144, 255, 0.18)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 32px rgba(24, 144, 255, 0.12)';
            }}>
              <div style={{ fontSize: 16, color: '#888', marginBottom: 12, fontWeight: 500 }}>昨日提交</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#1890ff' }}>{stats.countYesterday}</div>
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, rgba(24, 144, 255, 0.1) 0%, rgba(22, 101, 173, 0.1) 100%)',
                borderRadius: '0 20px 0 60px'
              }}></div>
            </div>

            {/* 上周提交数 */}
            <div className="stat-card" style={{ 
              background: 'linear-gradient(135deg, #fff 0%, #fafbfc 100%)', 
              borderRadius: 20, 
              padding: 32, 
              boxShadow: '0 8px 32px rgba(114, 46, 209, 0.12)', 
              border: '1px solid rgba(114, 46, 209, 0.08)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-4px)';
              e.target.style.boxShadow = '0 12px 40px rgba(114, 46, 209, 0.18)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 32px rgba(114, 46, 209, 0.12)';
            }}>
              <div style={{ fontSize: 16, color: '#888', marginBottom: 12, fontWeight: 500 }}>上周提交</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: '#722ed1' }}>{stats.countLastWeek}</div>
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '60px',
                height: '60px',
                background: 'linear-gradient(135deg, rgba(114, 46, 209, 0.1) 0%, rgba(88, 36, 162, 0.1) 100%)',
                borderRadius: '0 20px 0 60px'
              }}></div>
            </div>
          </div>


        </div>
      </div>

      {/* 动画样式 */}
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideInDown {
          from { 
            opacity: 0; 
            transform: translateY(-30px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }
        
        @keyframes slideInUp {
          from { 
            opacity: 0; 
            transform: translateY(30px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }
        
        @keyframes fadeInUp {
          from { 
            opacity: 0; 
            transform: translateY(40px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }
      `}</style>
    </>
  );
} 